import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './Introduction.css';

export function HobbiesIntroduction() {
  return (
    <header className="introduction">
      <h1 className="intro-heading">hi, i'm aidan</h1>
      <p className="location">
        <FaMapMarkerAlt className="location-icon" /> london, uk
      </p>
      <p className="intro-text">
        i enjoy building things, reviving old tech, and diving into challenges that stretch my thinking.
      </p>
    </header>
  );
}
